var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125.83 128.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{opacity:0.38;}.cls-10,.cls-4,.cls-8,.cls-9{mix-blend-mode:screen;}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-13,.cls-7{mix-blend-mode:multiply;}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:#99570e;}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2310.19,
    y1: -7383.25,
    x2: -2189.74,
    y2: -7383.25,
    gradientTransform: "translate(-2191.44 -7321.25) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6c440f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6c440f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ffd66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2252.17,
    y1: -7345.67,
    x2: -2252.17,
    y2: -7441.24,
    gradientTransform: "translate(-2183.56 -7325.02) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd86c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2256.39,
    y1: -7371.07,
    x2: -2256.39,
    y2: -7427.11,
    gradientTransform: "matrix(-0.63, 0.78, -0.78, -0.63, -7098.46, -2824.3)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2237.78,
    y1: -7352.88,
    x2: -2237.78,
    y2: -7395.29,
    gradientTransform: "matrix(-0.63, 0.78, -0.78, -0.63, -7098.46, -2824.3)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 365.45,
    y1: 820.83,
    x2: 365.45,
    y2: 923.74,
    gradientTransform: "matrix(0.63, -0.78, 0.78, 0.63, -838.35, -194.29)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 365.45,
    y1: 821.23,
    x2: 365.45,
    y2: 923.73,
    gradientTransform: "matrix(0.63, -0.78, 0.78, 0.63, -838.35, -194.29)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2301.86,
    y1: -7393.76,
    x2: -2202.47,
    y2: -7393.76,
    gradientTransform: "translate(-2183.26 -7325.16) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd86a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2302.33,
    y1: -7393.76,
    x2: -2202,
    y2: -7393.76,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2252.17,
    y1: -7363.74,
    x2: -2252.17,
    y2: -7408.42,
    gradientTransform: "translate(-2188.35 -7322.73) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc74e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff984d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2252.17,
    y1: -7391.07,
    x2: -2252.17,
    y2: -7414.17,
    gradientTransform: "matrix(-0.63, 0.78, -0.78, -0.63, -7098.46, -2824.3)",
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 60.73,
    cy: 62,
    rx: 64.31,
    ry: 58.27,
    transform: "translate(-25.66 70.29) rotate(-51.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 68.61,
    cy: 68.37,
    rx: 64.31,
    ry: 52,
    transform: "translate(-27.68 78.79) rotate(-51.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.16,116.63,107.68,17.3C97.63,9.82,85,7.3,72.18,9.23L53.62,128C66.34,128.83,80,124.85,92.16,116.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.18,117.55c.33.29.68.57,1,.85a42.72,42.72,0,0,0,11.59,6.67L57.22,13.48a71.75,71.75,0,0,0-15.15,8.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M109.07,101c22.31-27.64,22.29-64.67-.06-82.71S50.46,8.06,28.15,35.7s-22.29,64.66.05,82.7S86.75,128.67,109.07,101ZM28.57,36c22.08-27.35,57.91-35,80-17.19s22.13,54.5,0,81.84-57.9,35-80,17.19S6.49,63.38,28.57,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M109.07,101c22.31-27.64,22.36-64.61.1-82.58S50.78,8.32,28.47,36s-22.36,64.61-.11,82.58S86.75,128.67,109.07,101ZM28.89,36.29C51,9,86.73,1.2,108.75,19s22,54.37-.11,81.72S50.81,135.79,28.79,118,6.81,63.64,28.89,36.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 68.9,
    cy: 68.6,
    rx: 49.69,
    ry: 40.18,
    transform: "translate(-27.76 79.11) rotate(-51.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 68.9,
    cy: 68.6,
    rx: 50.16,
    ry: 40.56,
    transform: "translate(-27.76 79.11) rotate(-51.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 68.61,
    cy: 68.37,
    rx: 49.69,
    ry: 40.18,
    transform: "translate(-27.68 78.79) rotate(-51.08)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 63.82,
    cy: 64.5,
    rx: 47.78,
    ry: 33.11,
    transform: "translate(-26.46 73.63) rotate(-51.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M87.81,83.87C71.58,104,47.29,111.42,32.94,100.94c.28.25.56.49.86.73C48,113.16,73,105.83,89.57,85.29s18.49-46.48,4.26-58c-.29-.24-.59-.46-.9-.68C106.21,38.46,104.05,63.77,87.81,83.87Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin5);
export default __webpack_public_path__ + "static/media/coin5.3661aad2327ee4599b550281337788b8.svg";
export { ForwardRef as ReactComponent };